// extracted by mini-css-extract-plugin
module.exports = {"addToCart":"style_addToCart__3uTzu"};